<template>
  <Teleport to="body">
    <cl-modal
      :close-modal-text="$t('close')"
      :visible="visible"
      test-id="delete-confirmation-modal"
      @on-close="onClose"
    >
      <template #[`header.title`]>
        <slot name="title" />
      </template>
      <div>
        <slot name="body" />
      </div>
      <template #[`footer.decline`]>
        <slot name="decline">
          <cl-button
            variant="secondary-ghost"
            data-test-id="delete-confirmation-modal-cancel"
            @on-click="onClose"
          >
            {{ $t("cancel") }}
          </cl-button>
        </slot>
      </template>
      <template #[`footer.accept`]>
        <slot name="confirm">
          <cl-button
            variant="danger"
            data-test-id="delete-confirmation-modal-delete"
            :disabled="loading"
            @on-click="onConfirm"
          >
            <cl-spinner
              :loading-text="$t('loading')"
              v-if="loading"
              :size="'small'"
              class="tw-mr-2"
            />
            <span>{{ $t("delete") }}</span>
          </cl-button>
        </slot>
      </template>
    </cl-modal>
  </Teleport>
</template>

<script lang="ts" setup>
type Props = {
  visible?: boolean;
  loading?: boolean;
};
withDefaults(defineProps<Props>(), {
  visible: false,
  loading: false,
});

const emit = defineEmits<{
  (event: "on-confirm"): void;
  (event: "on-close"): void;
}>();

const onClose = () => {
  emit("on-close");
};
const onConfirm = () => {
  emit("on-confirm");
};
</script>
